export default "__VITE_ASSET__I3D9c_5I__"